import { buildReferralLink } from '@/lib/helpers/referral-api';
import { REFERRAL_SHARE_MESSAGE } from './constants';

const AV_COLORS = [
  '#22B573',
  '#0039CC',
  '#A65A00',
  '#5A2EAD',
  '#B30000',
  '#0B6B6B',
  '#1F4E79',
  '#7A4A00',
];

export function referralInitials(name: string) {
  return (name || '')
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function referralAvatarColor(name: string) {
  const code = (name || 'x').charCodeAt(0) || 0;
  return AV_COLORS[code % AV_COLORS.length];
}

export function formatReferralDate(value: string) {
  return new Date(value).toLocaleDateString('en-NG', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatRelativeTime(value: string) {
  const date = new Date(value);
  const diffMs = Date.now() - date.getTime();
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hr ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} day${days === 1 ? '' : 's'} ago`;
  return formatReferralDate(value);
}

export { buildReferralLink };

export const buildWhatsAppShareUrl = (link: string) => {
  const message = `${REFERRAL_SHARE_MESSAGE} ${link}`;
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
};

export const buildSmsShareUrl = (link: string) => {
  const message = `${REFERRAL_SHARE_MESSAGE} ${link}`;
  return `sms:?body=${encodeURIComponent(message)}`;
};

export const buildInstagramShareUrl = (link: string) => {
  const message = `${REFERRAL_SHARE_MESSAGE} ${link}`;
  return `https://www.instagram.com/direct/inbox/?text=${encodeURIComponent(message)}`;
};
